import React from 'react'
import PropTypes from 'prop-types'

import Title from "./Title";
import Text from "./Text";

import Button from "ui/Button";

import InstagramIcon from "assets/images/remix_icons/instagram.svg";
import LinktreeIcon from "assets/images/remix_icons/linktree.svg";

import TextField from "@mui/material/TextField";

import { t } from "i18n/index";

const SocialsForm = ({ step, organization, onChange, onInstagramSubmit, onLinktreeSubmit, loading }) => {
  
  const isStepOne = step === 1;
  const titleKey = isStepOne ? "account:signup:stepOne:title" : "account:signup:stepTwo:title";
  const descriptionKey = isStepOne ? "account:signup:stepOne:description" : "account:signup:stepTwo:description";
  const name = isStepOne ? "instagram_handle" : "linktree_handle";
  const value = isStepOne ? organization.instagram_handle : organization.linktree_handle;
  const icon = isStepOne ? InstagramIcon : LinktreeIcon;
  const iconSize = isStepOne ? "24px" : "22px";
  const urlPrefix = isStepOne ? "https://instagram.com/" : "https://linktree.com/";
  const onSubmit = isStepOne ? onInstagramSubmit : onLinktreeSubmit;
  
  return (
    <>
      <Title>{t(titleKey)}</Title>
      <Text>{t(descriptionKey)}</Text>

      <TextField 
        autoFocus
        name={name} 
        onChange={onChange} 
        small
        value={value || ""}
        color="warning"
        InputProps={{
          startAdornment: <div style={{display: "flex", alignItems: "center", gap: "8px"}}><img src={icon} style={{width: iconSize, height: iconSize}} />{urlPrefix}</div>
        }}
      />

      <Button fullwidth highlighted onClick={onSubmit} loading={loading}>
        {t("literal:continue")}
      </Button>
    </>
  );
};

SocialsForm.propTypes = {
  step: PropTypes.number,
  organization: PropTypes.object,
  onChange: PropTypes.func,
  onInstagramSubmit: PropTypes.func,
  onLinktreeSubmit: PropTypes.func,
  loading: PropTypes.bool,
};

export default SocialsForm;